const Offcanvas = ({ title, id, children }) => {
  return (
    <div
      className="offcanvas offcanvas-end offcanvas-responsive"
      id={id}
      tabIndex="-1"
      aria-labelledby={`${id}-label`}
    >
      <div className="offcanvas-header">
        <h5 id={`${id}-label`}>{title}</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
        ></button>
      </div>

      <div className="offcanvas-body">{children}</div>
    </div>
  );
};

export default Offcanvas;

